import yup from "../../../../utils/yup-extended";

export const variantFormValidationSchema = yup.object({
  showVariants: yup.boolean().required(),
  variants: yup.array().when("showVariants", {
    is: true,
    then: (schema) =>
      schema
        .of(
          yup.object({
            name: yup.string().trim().required("Variant name is required"),
            options: yup
              .array()
              .of(
                yup.object({
                  priceType: yup
                    .string()
                    .oneOf(["paid", "free"])
                    .required("Option type is required"),
                  name: yup.string().trim().required("Option title is required"),
                  currencies: yup.array().of(
                    yup.object().shape({
                      currency: yup.string().trim().required("Currency is required"),
                      price: yup
                        .number()
                        .required("Price is required")
                        .min(1, "Can't be less than 1")
                        .default(1)
                        .typeError("Must be a number"),
                    })
                  ),
                })
              )
              .min(1, "At least one option is required"),
          })
        )
        .min(1, "At least one variant is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
});

export const editVariantFormValidationSchema = yup.object({
  showVariants: yup.boolean().required(),
  variants: yup.array().when("showVariants", {
    is: true,
    then: (schema) =>
      schema
        .of(
          yup.object({
            id: yup.string().trim(),
            name: yup.string().trim().required("Variant name is required"),
            options: yup
              .array()
              .of(
                yup.object({
                  priceType: yup
                    .string()
                    .oneOf(["paid", "free"])
                    .required("Option type is required"),
                  id: yup.string().trim(),
                  name: yup.string().trim().required("Option title is required"),
                  currencies: yup.array().of(
                    yup.object().shape({
                      currency: yup.string().trim().required("Currency is required"),
                      price: yup
                        .number()
                        .required("Price is required")
                        .min(1, "Can't be less than 1")
                        .default(1)
                        .typeError("Must be a number"),
                    })
                  ),
                })
              )
              .min(1, "At least one option is required"),
          })
        )
        .min(1, "At least one variant is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
});
